// extracted by mini-css-extract-plugin
export default {"container":"quotation_container__jVG8v"};